import axios from 'axios'
import { WHATSAPP_SERVER } from '@/constants/config'

const api = axios.create({ baseURL: WHATSAPP_SERVER })
export default class WPApi {
  static async checkSessionStatus(session: any, token: string) {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    }
    return (await api.get(`${session}/check-connection-session`, config)).data
  }

  static async startSession(session: any, token: string) {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    }

    return (await api.post(`${session}/start-session`, null, config)).data
  }

  static async sendTestMessage(session: any, token: string, form: any) {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    }

    return (await api.post(`${session}/send-message`, form, config)).data
  }
}
